import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Global scroll-to-top on route change.
 *
 * React Router v6 does NOT reset scroll position automatically — without
 * this, a user who scrolled deep on /learn and then clicked a footer link
 * to /learn/pcos would land mid-page on the article. Mount this once near
 * the top of <BrowserRouter> so every navigation feels clean.
 *
 * Caveat: only triggers on real pathname changes — hash + search-only
 * navigations are deliberately left alone.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // requestAnimationFrame: let the new route's content render first
    // so the scroll target exists before we move.
    const frame = window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [pathname]);
  return null;
}
